
export default class FAQ {
  constructor() {
    var _this = this;
    _this.url 					= new URL(window.location.href);
    _this.deploy        = _this.url.searchParams.get('deploy');
    _this.category      = "";

    if ( ! _this.deploy ) {
      _this.deploy      = $($('.faq__item')[0]).attr('id')
    }
    console.log(_this.deploy);
    _this.getCategory()
    _this.showFaqItemFromCat(_this.category);

    rivets.formatters.e   = function(a, b){
      if( a == b ){
        return true;
      }else{
        return false;
      }
    }
    rivets.bind(document.querySelector('.faq'),{
        faq: _this
    });


    $('.faq__item').click(function(event) {
      _this.deploy = parseInt($(this).attr('id'));
      _this.updateUrlParam('deploy', _this.deploy);
      _this.getCategory()
    });

    $('.faq__nav-item').click(function(event) {
      var cat = $(this).text();
      _this.showFaqItemFromCat(cat);
      _this.openFirstQuestion(cat);
    });



  }
  updateUrlParam(k, v){
		if ( this.url.searchParams.has(k) ) {
			this.url.searchParams.set(k, v);
		}else{
			this.url.searchParams.append(k, v);
		}
		if (!history.replaceState) {
			return;
		}
		window.history.replaceState({path: this.url.href}, '', this.url.href);
	}
  getCategory(){
    this.category    = $('#'+this.deploy).data('category');
  }
  showFaqItemFromCat(cat){
    $('.faq__item').hide();
    $('.faq__item[data-category="'+ cat +'"]').show();
    this.category = cat;
  }
  openFirstQuestion(cat){
    var id = $('.faq__item[data-category="'+ cat +'"]:first').attr('id');
    this.deploy = id;
    this.updateUrlParam('deploy', this.deploy);
  }
}

